import React, { useEffect, useMemo, useRef, useState } from 'react';
import './ticker.scss';
/* import LogoA3Elecciones from './../../assets/logo_a3_elecciones_2019.svg'; */
import LogoA3Elecciones26M from "./../../assets/logo_elecciones26m.svg";
import { Fragment } from 'react';

const ANIMATION_TIME = 70;

export const Ticker = ({ congressAndSenateResults }) => {
  const { senate, congress } = congressAndSenateResults;
  const [leftPosition, setLeftPosition] = useState(0);
  const tickerTextElementRef = useRef();
  const style = useMemo(
    () => ({
      left: `${-leftPosition}px`,
      transition: `left ${leftPosition / ANIMATION_TIME}s linear`
    }),
    [leftPosition]
  );
  useEffect(() => {
    setLeftPosition(tickerTextElementRef.current.getBoundingClientRect().width);
  });

  const data = [
    {
      type: 'CONGRESO',
      partiesResult: congress.partiesResult
    },
    {
      type: 'SENADO',
      partiesResult: senate.partiesResult
    }
  ];

  return (
    <Fragment>
      <div className="ticker_container font-isidora">
        <div className="ticker">
          <div className="ticker_logo">
            <img
              src={LogoA3Elecciones26M}
              alt="Logo de Antena3 Elecciones"
              title="A3 Elecciones"
            />
          </div>
          <div className="ticker_content">
            <div
              className="ticker_text"
              ref={tickerTextElementRef}
              style={style}
            >
              {congress.partiesResult &&
                senate.partiesResult &&
                data.map(item => {
                  return (
                    <Fragment key={item.type}>
                      <span className="province_name">{`${item.type} `}</span>
                      <span className="province_separator">|</span>{" "}
                      {item.partiesResult
                        .filter(item => item.seats)
                        .map(result => {
                          return (
                            <span
                              key={`${result.partyAcronym}-${item.type}`}
                              className="province_percent"
                            >
                              {result.partyAcronym} : {result.seats} esc.
                              {" | "}
                            </span>
                          );
                        })}
                    </Fragment>
                  );
                })}
            </div>
          </div>
          <div className="ticker_hashtag">
            <a
              href="https://twitter.com/hashtag/EleccionesA3N?f=tweets"
              target="_blank"
              rel="noopener noreferrer"
            >
              #EleccionesA3N
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Ticker;
